// extracted by mini-css-extract-plugin
module.exports =  {"content":"content__pO7uX undefined","message":"message__zEj1h"};